module.exports = "/_next/static/images/prev-icon-b42c0048ceddc1ba944a821ff7eb702f.svg";